/**

 *

 * Most modern mobile touch slider and framework with hardware accelerated transitions

 * http://146.56.218.109:18086/wechat/index.html

 *

 * Copyright 2024-2031 Vladimir Kharlampidi

 *

 * Released under the MIT License

 *

 */



document.addEventListener("DOMContentLoaded", function() {


    const $priceDom = $('#sp_price1');
    const $cPriceDom = $('#sp_price2');
    const $offPriceDom = $('.sp-price-group .sp-p span');
    const $numDom = $('#calcNumber');
    console.log($offPriceDom,'777');
    
    const productData = window.product || []; 
    /** 获取当前选中的变量 */
    function getCur() {
        const opts = {
        option1: $('#sp-opt-color div.active').attr('data-val'),
        option2: $('#sp-opt-type div.active').attr('data-val'),
        option3: $('#sp-opt-group3 div.active').attr('data-val')
        };

        return productData.find(item => {
        return (!opts.option1 || item.option1 == opts.option1) &&
                (!opts.option2 || item.option2 == opts.option2) &&
                (!opts.option3 || item.option3 == opts.option3);
        });
    }
    console.log(getCur(),'888')
    /** 更新价格显示 */
    function changePrice() {
        const curVariant = getCur();
        if (!curVariant) return;

        const num = parseInt($numDom.val()) || 1;
        
        // 识别当前页面使用的小数点符号
        const currentText = $priceDom.text().trim();
        const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);
        
        const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'; 
        const decimalLength = decimalMatch ? decimalMatch[2].length : 0; 

        // 格式化输出
        const formatValue = (cents) => {
        let val = (cents * num / 100).toFixed(decimalLength);
        if (decimalSeparator === ',') {
            val = val.replace('.', ',');
        }
        return val;
        };

        const price = formatValue(curVariant.price);
        const compare = formatValue(curVariant.compare_at_price);
        
        // 计算折扣
        let offPercent = 0;
        if (curVariant.compare_at_price > curVariant.price) {
        offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
        }

        const priceRegex = /\d+(?:[.,]\d+)*/;
        const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

        const updateHTML = ($el, regex, value) => {
        if ($el && $el.length) {
            const text = $el[0].textContent.trim();
            const newHtml = text.replace(regex, value);
            if ($el.html() !== newHtml) {
            $el.html(newHtml);
            }
        }
        };

        updateHTML($priceDom, priceRegex, price);
        updateHTML($cPriceDom, priceRegex, compare);
        updateHTML($offPriceDom, offRegex, offPercent);
    }
    // 绑定选项点击事件
    $(document).on('click', '.sp-option', function() {
        setTimeout(changePrice, 10);
        console.log(changePrice(),'777')
    });

    $('.sp_buy_now').click(function () {

        let num = $numDom.val();
        let id = getCur().id;
        window.location.href = '/cart/' + id + ':' + num;

    });
    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2);
    }
    let spImgList = [];



    /**

     * 产品图片映射（根据颜色选项切换图片）

     * 1: Blue - 蓝色榨汁机

     * 2: Green - 绿色榨汁机

     * 3: Blue+Green - 蓝色+绿色组合

     */

    var productImages = {

        "1-0": "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20260413-p-1.png",

        "2-0": "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20260413-p-2.png",

        "3-0": "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20260413-p-3.png",

        "1-1": "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20260413-p-4.png",

        "2-1": "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20260413-p-5.png",

        "3-1": "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20260413-p-6.png"

    };



    /**

     * 更新价格显示

     * 根据选中的颜色、类型选项和数量计算总价

     */

    function updatePriceDisplay() {

        // 获取颜色选项

        var colorOption = $("#sp-opt-color .sp-option.active");

        // 获取类型选项（清洁刷附加费）

        var typeOption = $("#sp-opt-type .sp-option.active");

        var quantity = parseInt($("#calcNumber").val()) || 1;



        // // 获取颜色选项的基础价格和原价

        // var basePrice = parseFloat(colorOption.data("price")) || 49.99;

        // var originalPrice = parseFloat(colorOption.data("original")) || 119.99;

        // var discount = colorOption.data("discount") || 58;



        // // 获取类型选项的附加费用

        // var addPrice = parseFloat(typeOption.data("add")) || 0;



        // // 计算总价（(颜色基础价 + 类型附加费) * 数量）

        // var totalPrice = (basePrice + addPrice) * quantity;

        // var totalOriginal = originalPrice * quantity;



        // // 更新显示

        // $("#sp_price1").html(totalPrice.toFixed(2));

        // $("#sp_price2").html(totalOriginal.toFixed(2));

        // $("#sp_discount").html(discount + "%");



        // 更新颜色文字显示

        var colorText = colorOption.data("color") || "Blue";

        $("#sp-color-text").html(colorText);



        // 更新类型文字显示

        var typeText = typeOption.data("type") || "Only Fruit Juicer";

        $("#sp-type-text").html(typeText);

    }



    // 数量减少按钮

    $(".sp-reduce").click(function() {

        let input = $(this).siblings("input")[0];

        let num = Number(input.value) - 1;

        if (num > 0) {

            input.value = num;

        }

        changePrice();

    });



    // 数量增加按钮

    $(".sp-add").click(function() {

        let input = $(this).siblings("input")[0];

        let num = Number(input.value) + 1;

        input.value = num;

        changePrice();

    });



    // 选项点击事件（Style、套餐、灯串）

    $(".sp-option").click(function() {

        $(this).siblings().removeClass("active");

        $(this).addClass("active");



        updateProductDisplay();
        changePrice()
        updatePriceDisplay();

    });



    // sp-part4 层叠轮播（循环，不隐藏）

    var part4AutoPlay;

    var part4CurrentIndex = 0;

    var part4Total = 5; // 固定5张图片



    // 更新图片位置类（所有图片都显示，循环排列）

    function updatePart4Positions() {

        $(".sp-part4 .sp-tab-img-wrap").each(function() {

            var imgIndex = $(this).data("index");

            // 计算相对于当前激活项的位置（循环）

            // 当前图片是pos-1，后面依次是pos-2,3,4,5

            var relativePos = (imgIndex - part4CurrentIndex + part4Total) % part4Total;



            // 移除所有位置类

            $(this).removeClass("pos-1 pos-2 pos-3 pos-4 pos-5");



            // 添加对应位置类

            $(this).addClass("pos-" + (relativePos + 1));

        });



        // 更新选项卡状态

        $(".sp-part4 .sp-tab-item").removeClass("active");

        $(".sp-part4 .sp-tab-item[data-index='" + part4CurrentIndex + "']").addClass("active");

    }



    // 初始化位置

    updatePart4Positions();



    // sp-part4 选项卡点击

    $(".sp-part4 .sp-tab-item").click(function() {

        part4CurrentIndex = $(this).data("index");

        updatePart4Positions();

    });



    // sp-part4 自动轮播（向下循环）

    function startPart4AutoPlay() {

        part4AutoPlay = setInterval(function() {

            part4CurrentIndex = (part4CurrentIndex + 1) % part4Total;

            updatePart4Positions();

        }, 2000);

    }



    startPart4AutoPlay();



    // 鼠标悬停时暂停自动轮播

    $(".sp-part4-content").hover(

        function() {

            clearInterval(part4AutoPlay);

        },

        function() {

            startPart4AutoPlay();

        }

    );



    /**

     * sp-part5 Why We Are Better 轮播初始化

     * PC端和移动端使用Swiper实现自动+手动轮播

     */

    // PC端轮播（中间2张完整，两边各半张）

    new Swiper(".sp-part5-swiper", {

        slidesPerView: "auto",

        spaceBetween: 28,

        centeredSlides: true,

        loop: true,

        slidesPerGroup: 1,

        autoplay: {

            delay: 3000,

            disableOnInteraction: false,

        },

        speed: 500,

    });



    // 移动端轮播（居中显示，左右露出部分）

    new Swiper(".sp-part5-swiper-m", {

        slidesPerView: "auto",

        spaceBetween: 30,

        centeredSlides: true,

        loop: true,

        autoplay: {

            delay: 3000,

            disableOnInteraction: false,

        },

        speed: 500,

    });



    /**

     * sp-part2 移动端图标走马灯

     */

    new Swiper(".sp-part2-icons-swiper", {

        slidesPerView: 3,

        spaceBetween: 20,

        loop: true,

        autoplay: {

            delay: 2500,

            disableOnInteraction: false,

        },

        speed: 500,

    });



    /**

     * sp-part2 移动端果汁卡片走马灯

     */

    new Swiper(".sp-part2-cards-swiper", {
        slidesPerView: "auto",
        spaceBetween: 20,
        loop: true,
        loopAdditionalSlides: 3,
        speed: 3000,
        allowTouchMove: false, // 加这行
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        freeMode: {
            enabled: true,
            momentum: false,
        },
    });



    /**

     * sp-part6 How to Use 移动端轮播初始化

     * 居中显示，左右露出部分

     */

    new Swiper(".sp-part6-swiper-m", {

        slidesPerView: "auto",

        spaceBetween: 30,

        centeredSlides: true,

        loop: false,

        autoplay: {

            delay: 3000,

            disableOnInteraction: false,

        },

        speed: 500,

    });



    // sp-part6 抽屉式卡片点击切换 + 自动轮播

    var part6AutoPlay;

    var part6CurrentIndex = 0; // 从第1张开始按顺序轮播

    var part6Total = 4;



    function updatePart6Display(index) {

        $(".sp_pc .sp-part6 .sp-drawer-card").removeClass("active");

        $(".sp_pc .sp-part6 .sp-drawer-card[data-index='" + index + "']").addClass("active");

    }



    function startPart6AutoPlay() {

        // 先清除已有定时器，防止定时器叠加导致轮播变快

        clearInterval(part6AutoPlay);

        part6AutoPlay = setInterval(function() {

            part6CurrentIndex = (part6CurrentIndex + 1) % part6Total;

            updatePart6Display(part6CurrentIndex);

        }, 3500);

    }



    startPart6AutoPlay();



    // 手动点击切换

    $(".sp_pc .sp-part6 .sp-drawer-card").on("click", function() {

        var index = $(this).data("index");

        part6CurrentIndex = index;

        updatePart6Display(index);

        clearInterval(part6AutoPlay);

        startPart6AutoPlay();

    });



    // 鼠标悬停暂停

    $(".sp_pc .sp-part6 .sp-drawer-cards").hover(

        function() {

            clearInterval(part6AutoPlay);

        },

        function() {

            startPart6AutoPlay();

        }

    );



    /**

     * 更新产品显示（图片）

     * 根据颜色选项切换产品主图

     */

    function updateProductDisplay() {

        // 获取当前选中的颜色对应的图片索引

        var colorImgIndex = $("#sp-opt-color .sp-option.active").data("img") || 1;

        // 获取当前选中的类型索引（0=Only Fruit Juicer, 1=With Cleaning Brush）

        var typeIndex = 0;

        // 组合键: "颜色索引-类型索引"

        var imgKey = colorImgIndex + "-" + typeIndex;



        // 更新产品主图

        if (productImages[imgKey]) {

            $("#sp-main-product-img").attr("src", productImages[imgKey]);

        }

    }



    // 倒计时

    function getRandomNum(min, max) {

        return Math.floor(Math.random() * (max - min)) + min;

    }



    let endTimeG;



    function cutDownTime() {

        let nowTime = new Date();

        let endTime = new Date(endTimeG);



        let leftTime = endTime.getTime() - nowTime.getTime();

        if (leftTime < 0) {

            setupNewCountdown();

            leftTime = 0;

        }

        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),

            leftM = Math.floor((leftTime / (1000 * 60)) % 60),

            leftS = Math.floor((leftTime / 1000) % 60);

        leftH = leftH >= 10 ? leftH : "0" + leftH;

        leftM = leftM >= 10 ? leftM : "0" + leftM;

        leftS = leftS >= 10 ? leftS : "0" + leftS;



        return {

            hour: leftH,

            minute: leftM,

            second: leftS,

        };

    }



    function setupNewCountdown() {

        const randomHour = getRandomNum(1, 9);

        const currentTime = new Date();

        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);

    }

    let intervalId;



    function getCutDownTime() {

        setupNewCountdown();

        if (intervalId) clearInterval(intervalId);

        intervalId = setInterval(function() {

            let cutDownTimeText = cutDownTime();

            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);

            $(".sp_top_cut_down .sp_left_view .sp_minute").html(

                cutDownTimeText.minute

            );

            $(".sp_top_cut_down .sp_left_view .sp_second").html(

                cutDownTimeText.second

            );

        }, 1000);

    }



    getCutDownTime();



    // 初始化 sp-num2 和 sp-num4 的显示状态

    $(".sp-num2, .sp-num4").hide(); // 先隐藏所有

    let initialNumOptions = $(".sp-opt-group2 .sp-option.active").index();

    if (initialNumOptions === 0) {

        $(".sp-num2").show(); // 默认显示 X2

    } else if (initialNumOptions === 1) {

        $(".sp-num4").show(); // 显示 X4

    }



    new Swiper(".sp-swiper-fade-top", {

        spaceBetween: 10,

        effect: "fade",

        autoplay: true,

        autoplay: {

            disableOnInteraction: false,

            delay: 2000,

        },

        speed: 2000,

    });



    // // 按钮轮播

    new Swiper(".sp-btn-loop", {

        spaceBetween: 10,

        autoplay: true,

        autoplay: {

            disableOnInteraction: false,

            reverseDirection: true,

        },

        loop: true,

    });



    new Swiper(".sp-swiper1", {

        spaceBetween: 60,

        autoplay: true,

        autoplay: {

            disableOnInteraction: false,

            delay: 0,

        },

        loop: true,

        speed: 6000,

        slidesPerView: "auto",

    });

    new Swiper(".sp-swiper1-m", {

        spaceBetween: 30,

        autoplay: true,

        autoplay: {

            disableOnInteraction: false,

            delay: 0,

        },

        loop: true,

        speed: 6000,

        slidesPerView: "auto",

    });



    new Swiper(".sp-swiper3", {

        autoplay: {

            delay: 2500,

            disableOnInteraction: false,

        },

        speed: 300,

        effect: "slide",

        slideShadows: true,

        slidesPerView: "auto",

        spaceBetween: 0,

        centeredSlides: true,

        loop: true,

        pagination: {

            el: ".sp-pagination3",

            clickable: true,

        },

    });



    new Swiper(".sp-swiper4", {

        autoplay: {

            delay: 2500,

            disableOnInteraction: false,

        },

        speed: 300,

        effect: "slide",

        slideShadows: true,

        slidesPerView: "auto",

        spaceBetween: 0,

        centeredSlides: true,

        loop: true,

        pagination: {

            el: ".sp-pagination4",

            clickable: true,

        },

    });



    new Swiper(".sp-swiper6", {

        autoplay: {

            delay: 2500,

            disableOnInteraction: false,

        },

        speed: 300,

        effect: "slide",

        slideShadows: true,

        slidesPerView: "auto",

        spaceBetween: 11,

        centeredSlides: true,

        loop: true,

        pagination: {

            el: ".sp-pagination6",

            clickable: true,

        },

    });



    new Swiper(".sp-swiper7", {

        autoplay: {

            delay: 2500,

            disableOnInteraction: false,

        },

        speed: 300,

        effect: "slide",

        slideShadows: true,

        slidesPerView: "auto",

        spaceBetween: 0,

        centeredSlides: true,

        loop: true,

        pagination: {

            el: ".sp-pagination7",

            clickable: true,

        },

    });



    if (document.body.clientWidth <= 1080) {

        new Swiper(".sp-info4-swiper", {

            autoplay: {

                delay: 0,

                disableOnInteraction: false,

                pauseOnMouseEnter: false,

            },

            speed: 4000,

            spaceBetween: 40,

            loop: true,

            loopAdditionalSlides: 3,

            slidesPerView: "auto",

            freeMode: {

                enabled: true,

                momentum: false,

            },

            allowTouchMove: false,

            grabCursor: false,

        });

    }



    jQuery(".sp-scroll1").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "leftMarquee",

        interTime: 12,

        vis: 1,

        scroll: 1,

    });



    jQuery(".sp-scroll2-m").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "leftMarquee",

        interTime: 12,

        vis: 1,

        scroll: 1,

    });



    jQuery(".sp-scroll4-pc").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "leftMarquee",

        interTime: 12,

        vis: 1,

        scroll: 1,

    });



    jQuery(".sp-scroll4").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "leftMarquee",

        interTime: 12,

        vis: 1,

        scroll: 1,

    });



    jQuery(".sp-scroll6").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "leftMarquee",

        interTime: 12,

        vis: 1,

        scroll: 1,

    });



    jQuery(".sp-scroll6-m").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "leftMarquee",

        interTime: 12,

        vis: 1,

        scroll: 1,

    });



    // 移动端 How to Use 步骤轮播（居中显示，左右露出部分）

    jQuery(".sp-scroll-part6-m").slide({

        mainCell: ".nav-imgs",

        autoPlay: true,

        effect: "left",

        interTime: 3000,

        delayTime: 500,

        vis: 1,

        scroll: 1,

        pnLoop: true,

    });



    let _swiper = new Swiper(".sp-swiper-pro", {

        speed: 1,

        spaceBetween: 0,

    });



    function mainRender() {

        $(function() {

            $("#root").css("zoom", "normal");

            if (document.body.clientWidth <= 1080) {

                let scale = document.body.clientWidth / 1080;

                $("#root").css("zoom", scale);

            } else {

                const scale = document.body.clientWidth / 1920;

                $("#root").css("zoom", scale);

            }



            window.addEventListener(

                "resize",

                (function() {

                    var timer;

                    return function() {

                        if (timer) clearTimeout(timer);

                        timer = setTimeout(function() {

                            $("#root").css("zoom", "normal");

                            if (document.body.clientWidth <= 1080) {

                                let scale = document.body.clientWidth / 1080;

                                $("#root").css("zoom", scale);

                            } else {

                                const scale = document.body.clientWidth / 1920;

                                $("#root").css("zoom", scale);

                            }

                        }, 100);

                    };

                })()

            );

        });



        function lazyLoadImages() {

            // 懒加载

            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片

            const config = {

                rootMargin: "0px 0px 1300px 0px",

                threshold: 0,

            };



            const lazyLoadObserver = new IntersectionObserver(function(

                    entries,

                    observer

                ) {

                    entries.forEach(function(entry) {

                        if (entry.isIntersecting) {

                            // 当图片进入视口时

                            const image = entry.target;

                            const dataSrc = image.getAttribute("data-src");

                            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址

                            lazyLoadObserver.unobserve(image); // 停止观察该图片

                        }

                    });

                },

                config);



            images.forEach(function(image) {

                lazyLoadObserver.observe(image); // 开始观察每个图片

            });

        }



        function preloadImages(imageArray) {

            // 预加载

            // 检查数组数据结构

            if (Array.isArray(imageArray[0])) {

                // 处理二维数组

                imageArray.forEach((subArray) => {

                    subArray.forEach((url) => {

                        const img = new Image();

                        img.src = url;

                    });

                });

            } else {

                // 处理一维数组

                imageArray.forEach((url) => {

                    const img = new Image();

                    img.src = url;

                });

            }

        }



        lazyLoadImages();



        preloadImages(spImgList);



        var links = document.querySelectorAll('a[href^="#shopping"]');

        links.forEach(function(link) {

            link.addEventListener("click", function(event) {

                event.preventDefault(); // 阻止默认的跳转行为



                // 方式一

                const targetElement = document.getElementById("shopping"); // 获取跳转目标节点

                const offsetTop =

                    document.body.clientWidth <= 1080 ?

                    targetElement.offsetTop - $(".sp-nav").height() :

                    targetElement.offsetTop;

                let sptop = document.body.clientWidth <= 1080 ? 0 : 60;



                window.scroll({

                    top: offsetTop * $("div#root").css("zoom") -

                        sptop * $("div#root").css("zoom"),

                    behavior: "smooth", // 使用 smooth 实现平滑滚动

                });

            });

        });



        var links_GUARANTEES = document.querySelectorAll('a[href^="#GUARANTEES"]');

        links_GUARANTEES.forEach(function(link) {

            link.addEventListener("click", function(event) {

                event.preventDefault(); // 阻止默认的跳转行为



                // 方式一

                const targetElement = document.getElementById("GUARANTEES"); // 获取跳转目标节点

                const offsetTop =

                    document.body.clientWidth <= 1080 ?

                    targetElement.offsetTop - $(".sp-nav").height() :

                    targetElement.offsetTop;

                let sptop = document.body.clientWidth <= 1080 ? 0 : 60;

                0;



                window.scroll({

                    top: offsetTop * $("div#root").css("zoom") -

                        sptop * $("div#root").css("zoom"),

                    behavior: "smooth", // 使用 smooth 实现平滑滚动

                });

            });

        });



        // IOS字体多了间距的处理 给节点添加 sp_system 类名

        // 判断当前用户是安卓端还是iOS端

        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        var isAndroid = /android/i.test(userAgent);

        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断



        if (isAndroid) {

            console.log("Android");

        } else if (isIOS) {

            console.log("iOS");

        } else if (isPC) {

            console.log("PC");

        } else {

            $(".sp_system").css("letter-spacing", "-4px");

        }

    }



    mainRender();



    // 标题文本渐出

    const graduallyList = document.getElementsByClassName("gradually");

    for (let gradually of graduallyList) {

        const spans = gradually.querySelectorAll("span");

        const paragraph = gradually.querySelector(".sp-sub-title");



        const observer = new IntersectionObserver(

            (entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {

                        // 给每个 span 和 i 动画

                        spans.forEach((span, index) => {

                            span.style.animation = `swift-up-fade 0.5s ease forwards`;

                            span.style.animationDelay = `${index * 0.1}s`;



                            const i = span.querySelector("i");

                            if (i) {

                                i.style.animation = `swift-up-fade 0.5s ease forwards`;

                                i.style.animationDelay = `${index * 0.1}s`;

                            }

                        });



                        // 段落

                        const totalDelay = spans.length * 0.1 + 0.3;

                        if (paragraph) {

                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;

                            paragraph.style.animationDelay = `${totalDelay}s`;

                        }



                        observer.unobserve(gradually);

                    }

                });

            }, {

                threshold: 0.3,

            }

        );

        observer.observe(gradually);

    }



    // // 点击按钮

    // $(".sp-video-btn").click(function () {

    //   $(".sp-mask").css("display", "flex");

    // });



    // 菜单

    $(".sp-menu-btn").click(function(e) {

        $(".sp-menu-mask").show();

    });



    $(".sp-menu-mask").click(function(e) {

        // if ($(e.target).closest(".sp-menu-mask li").length > 0) {

        // } else {

        $(".sp-menu-mask").hide();

        // }

    });



    // 滚动隐藏顶部

    if (

        $(window).scrollTop() >

        $(".sp_header").height() * $("div#root").css("zoom")

    ) {

        $(".sp_header-wrap").addClass("sp-fixed");

    } else {

        $(".sp_header-wrap").removeClass("sp-fixed");

    }



    let spTimer = null;

    let spHasShown = false; // 防止重复显示



    $(window).scroll(function() {

        if (

            $(window).scrollTop() >

            $(".sp_header").height() * $("div#root").css("zoom")

        ) {

            $(".sp_header-wrap").addClass("sp-fixed");

        } else {

            $(".sp_header-wrap").removeClass("sp-fixed");

        }



        // 滚动添加底部

        if (spHasShown) return; // 已经显示就不再触发



        // 如果没有定时器，则开始计时（移动端滚动后才显示）

        if (!spTimer && $(window).scrollTop() > 100) {

            spTimer = setTimeout(function() {

                document.querySelector(".sp-btn-style2").style.display = "flex";

                spHasShown = true; // 标记为已显示

            }, 3000);

        }

    });



    $(document).on("click", ".sp_buy_now", function() {

        console.log("xxx111");

    });



    let initNum = 0;

    $(document).on("click", ".sp_add_cart", function() {

        // 购物车加购动效



        $(this).children("img").addClass("on");

        $(".sp-cart .num").show();

        setTimeout(function() {

            $(" .cart-btn").children("img").removeClass("on");

        }, 500);

        $(" .sp-cart").addClass("on");

        setTimeout(function() {

            $(".sp-cart").removeClass("on");

        }, 500);



        let spNum = $(".sp_product_part #calcNumber")[0].value;

        initNum += Number(spNum);



        // $("#calcNumber").val(1);



        /* $(".cardNum").each(function() {

            $(this).html(initNum);

        }); */

    const data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').html(result.item_count)
          $('.cardNum').removeClass('sp-gray')
        })
      },
      dataType: 'json',
    })


        $(".cardNum").removeClass("sp-gray");

        // handleAddToCart(initNum);



        // 飞入购物车动画

        var imgs = $(".sp_product_part .sp-product-main-img").find("img");



        imgs.each(function() {

            var $img = $(this);

            var flyer = $img[0].cloneNode(true);

            flyer.classList.add("sp_clone");



            $(".sp_product_part").append(flyer);

            $(flyer).css({

                width: $img[0].width,

                height: $img[0].height,

                background: "#e7e9ef",

                position: "fixed",

                top: $img[0].offsetTop,

                left: $img.offset().left,

                "z-index": 99,

            });



            let finish;

            if (document.body.clientWidth <= 1080) {

                finish = $(".sp-mobile-sticky-cart");

                $(flyer).animate({

                        top: $(".sp-mobile-sticky-bottom")[0].offsetTop,

                        left: $(".sp-mobile-sticky-right")[0].offsetLeft + finish.width() / 2,

                        width: 50,

                        height: 50,

                        opacity: 0.4,

                    },

                    500,

                    "linear",

                    function() {

                        $(this).animate({

                                width: 0,

                                height: 0,

                                opacity: 0,

                            },

                            0,

                            function() {

                                $(this).detach();

                            }

                        );

                    }

                );

            } else {

                finish = $(".sp_pc .sp-cart");

                $(flyer).animate({

                        top: finish[0].offsetTop,

                        left: finish[0].offsetLeft + finish.width() / 2,

                        width: 50,

                        height: 50,

                        opacity: 0.4,

                    },

                    500,

                    "linear",

                    function() {

                        $(this).animate({

                                width: 0,

                                height: 0,

                                opacity: 0,

                            },

                            0,

                            function() {

                                $(this).detach();

                            }

                        );

                    }

                );

            }

        });

    });



    // 滚动添加底部（首屏不添加，滚动后出现）

    $(window).on("scroll", function() {

        var scrollTop = $(window).scrollTop();



        // 首屏不显示按钮

        if (scrollTop <= 100) {

            $(".sp-btn-style2").removeClass("sp-fixed-bottom");

            $(".sp-btn-style2").css("display", "none");

        } else {

            // 滚动后根据位置决定是否固定在底部

            if (

                scrollTop >

                $(".sp-part1").height() * $("div#root").css("zoom") -

                $(".sp-part1 .sp-content").height() * $("div#root").css("zoom")

            ) {

                $(".sp-btn-style2").addClass("sp-fixed-bottom");

            } else {

                $(".sp-btn-style2").removeClass("sp-fixed-bottom");

            }

        }

    });



    // QA3 展开/收起功能

    $('.sp-qa3-question').on('click', function() {

        var $currentItem = $(this).closest('.sp-qa3-item');

        var $answer = $currentItem.find('.sp-qa3-answer');



        if ($currentItem.hasClass('active')) {

            $answer.slideUp(300);

            $currentItem.removeClass('active');

        } else {

            $('.sp-qa3-item').removeClass('active');

            $('.sp-qa3-answer').slideUp(300);

            $currentItem.addClass('active');

            $answer.slideDown(300);

        }

    });



    // 文本渐出动画

    const graduallyList2 = document.getElementsByClassName("sp-fade-box");

    for (let gradually2 of graduallyList2) {

        const paragraph2 = gradually2.querySelectorAll(".sp-ani");



        const observerAni = new IntersectionObserver(

            (entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {

                        paragraph2.forEach((span, index) => {

                            span.style.animation = `sp-fade-in 1s ease forwards`;

                            span.style.animationDelay = `${index * 0.5 + 0.5}s`;

                        });



                        observerAni.unobserve(gradually2);

                    }

                });

            }, {

                threshold: 0.2,

            }

        );

        observerAni.observe(gradually2);

    }

    const leftAniList = document.querySelectorAll(".sp-ani-left");
    leftAniList.forEach((item) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.style.animation = `sp-fade-in-left 1.5s ease forwards`;
                        entry.target.style.animationDelay = `1.5s`;
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observer.observe(item);
    });

    const rightAniList = document.querySelectorAll(".sp-ani-right");
    rightAniList.forEach((item) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.style.animation = `sp-fade-in-right 1.8s ease forwards`;
                        entry.target.style.animationDelay = `1.8s`;
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observer.observe(item);
    });

    // 文本渐出动画

    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");

    for (let gradually3 of graduallyList3) {

        const paragraph3 = gradually3.querySelectorAll(".sp-ani2");



        const observerAni = new IntersectionObserver(

            (entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {

                        paragraph3.forEach((span, index) => {

                            span.style.animation = `sp-fade-left 1s ease forwards`;

                            span.style.animationDelay = `${index * 0.3 + 1}s`;

                        });



                        observerAni.unobserve(gradually3);

                    }

                });

            }, {

                threshold: 0.3,

            }

        );

        observerAni.observe(gradually3);

    }

});